export enum Role {
  SYSTEM_MANAGER = 'Advisor',
  SYSTEM_READER = 'System Reader',
  GMF_ADVISOR = 'GMF Advisor',
  ORG_MANAGER = 'Account Admin',
  HUB_MANAGER = 'Hub Manager',
  FLEET_MANAGER = 'Fleet Manager',
  OPERATOR = 'Operator',
  VIEWER = 'Viewer',
  TECHNICAL_MANAGER = 'Technical Manager',
}

export const GLOBAL_ROLES = [
  Role.SYSTEM_MANAGER,
  Role.SYSTEM_READER,
  Role.TECHNICAL_MANAGER,
];
